<template>
  <div :id="blok.type" v-editable="props.blok" class="optin-wrapper">
    <ErrorMessage
      error-message="Setzen Sie hier den Haken, indem Sie auf das Kästchen klicken."
      :has-error="hasError"
    />
    <div class="optin">
      <PflegeCheckbox
        v-model="referredModelValue"
        :required="props.required"
        :has-error="hasError"
        class="optin-checkbox"
        @update:model-value="onInputChange($event)"
      >
        <template #label>
          <WizcoRichtextResolver
            v-if="!showExpandableContent"
            :blok="props.blok.content"
            class="text-s"
          />
          <span
            v-if="hasExpandableContent && !showExpandableContent"
            class="optin-expand text-bold text-s"
            @click.prevent="showExpandableContent = true"
          >
            mehr anzeigen
            <PflegeIcon name="chevron-down-line" />
          </span>
          <WizcoRichtextResolver
            v-if="showExpandableContent"
            :blok="props.blok.expandableContent"
            class="text-s"
          />
        </template>
      </PflegeCheckbox>
      <PflegeInfotooltip v-if="props.blok.infoContent?.content?.[0]?.content" icon="info">
        <WizcoRichtextResolver :blok="props.blok.infoContent" class="text-s" />
      </PflegeInfotooltip>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, shallowRef } from 'vue'
import ErrorMessage from '../../input/ErrorMessage.vue'

const props = defineProps({
  blok: {
    type: Object,
    required: true
  },
  modelValue: {
    type: [Boolean, String],
    required: false,
    default: false
  },
  label: {
    type: [Object, String],
    required: false,
    default: ''
  },
  expandableLabel: {
    type: [Object, String],
    required: false,
    default: ''
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  },
  hasError: {
    type: Boolean,
    required: false,
    default: false
  }
})
const emit = defineEmits(['input'])

const hasExpandableContent = computed(() => {
  return !!generatedLabelPlain(props.blok.expandableContent)
})
const showExpandableContent = shallowRef(false)
const referredModelValue = ref(
  typeof props.modelValue !== 'undefined' && props.modelValue !== '' && props.modelValue !== false
) // detour to (un/)check if text is available

const generatedLabelPlain = (richTextContent) => {
  let plainText = ''
  richTextContent.content.forEach((row) => {
    if (row.type !== 'blok') {
      row.content?.forEach((textNode) => {
        if (typeof textNode.text === 'string') {
          plainText += textNode.text
        }
      })
    }
  })
  return plainText
}

const onInputChange = (isChecked) => {
  if (!isChecked) {
    emit('input', props.blok.type, null)
  } else {
    emit('input', props.blok.type, generatedLabelPlain(props.blok.content))
  }
}
</script>

<style scoped>
.optin-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.optin {
  display: flex;
}

.optin-expand {
  display: flex;
  margin-top: 0.5rem;
  gap: 0.25rem;
  align-items: center;
}

.optin .checkbox {
  flex-grow: 1;
}

.text-s :deep(p) {
  font-size: 0.9rem;
}
</style>
